import {
  COMPARE_PROVIDERS,
  COMPARE_PROVIDERS_SUCCESS,
  COMPARE_PROVIDERS_ERROR,
  RESET_COMPARISON_SUCCESS
} from './Comparator.actions'

const initialState = {
  data: { firstEntity: null, secondEntity: null },
  fetching: false,
  fetched: false,
  error: null
}

/**
 * Comparator's reducer.
 */
const comparatorReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case COMPARE_PROVIDERS: {
      return { ...state, fetching: true }
    }
    case COMPARE_PROVIDERS_ERROR: {
      return { ...state, error: payload.error }
    }
    case COMPARE_PROVIDERS_SUCCESS: {
      return { ...state, data: payload, fetching: false, fetched: true }
    }
    case RESET_COMPARISON_SUCCESS: {
      return initialState
    }
    default: {
      return state
    }
  }
}

export default comparatorReducer
